import styled from 'styled-components';

import { Radio } from 'ui/radio';
import noop from 'utils/noop';
import { BasicOption } from '../BasicOption';
import { BasicOptionProps, SelectValueType } from '../types';

const StyledRadio = styled(Radio)``;

export const RadioOption = <TValue extends SelectValueType = string>({
  isSelected,
  ...props
}: BasicOptionProps<TValue>) => {
  return (
    <BasicOption
      Prefix={
        <StyledRadio
          isChecked={isSelected || false}
          size={20}
          id="Radio-Option"
          onClick={noop}
          value=""
          tabIndex={-1}
        />
      }
      {...props}
    />
  );
};
